import { render, staticRenderFns } from "./addgoods.vue?vue&type=template&id=1a785c9b&scoped=true&"
import script from "./addgoods.vue?vue&type=script&lang=js&"
export * from "./addgoods.vue?vue&type=script&lang=js&"
import style0 from "./addgoods.vue?vue&type=style&index=0&id=1a785c9b&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a785c9b",
  null
  
)

export default component.exports